/********************************************
 * Gravity Forms
 ********************************************/
function fnGform( i, oSection ) {

	var oSection 			= $( oSection ),
		oInputWrap			= $( '.ginput_container', oSection ),
		oInput				= $( 'input, textarea', oSection ),
		oSelect				= $( '.ginput_container_select', oSection ),
		oSubmit				= $( '.gform_button', oSection );

	/**
	 * Initiate dropdowns (Dropkick.js)
	 */
	oSelect.find( 'select' ).dropkick({ mobile: true });

	/**
	 * Input interaction
	 */
	oInput.focus( function() {
		$( this ).closest( oInputWrap ).addClass( "is-active is-completed" );
	});

	oInput.focusout( function() {
		if ( $( this ).val() === "" ) {
			$( this ).closest( oInputWrap ).removeClass( "is-completed" );
			$( this ).closest( oInputWrap ).removeClass( "is-active" );
		}
	});


	$('.gfield .gsection_title').each(function(){
		var oTitle = $(this);
		oTitle.html(oTitle.html().replace(/([^\s]+)/, '<span>$1</span>'));
	});


	//Gform Render
	$(document).on('gform_post_render', function (event, form_id, current_page) {

		// code to trigger on form or form page render
		oSection.each(fnGform);                                // Gform

	});


}


/* END OF DOCUMENT */
